import { render, staticRenderFns } from "./ForecastFinalResultIndependent.vue?vue&type=template&id=24666937&scoped=true&"
import script from "./ForecastFinalResultIndependent.vue?vue&type=script&lang=js&"
export * from "./ForecastFinalResultIndependent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24666937",
  null
  
)

export default component.exports